import { QueryClient } from '@tanstack/react-query';

import { ApiClientError } from './api';

/**
 * One client for the whole app.
 *
 * - `staleTime: 60s` — NAV data changes at most once a day; refetching on every
 *   pill click would be noise. Switching timeframe/fund inside the window is
 *   instant because the cache serves it.
 * - `retry: 1` — one retry absorbs a flaky first request; more than that just
 *   delays the error state the user needs to see. 4xx is never retried: a
 *   `FUND_NOT_FOUND` will not become found.
 * - No refetch on window focus — this dashboard sits open on a second monitor.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiClientError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});
